import type { PartnerStatus } from "@redotech/admin-sdk/rpc/schema/partners/shared";
import PlusIcon from "@redotech/redo-icons/plus.svg";
import SearchIcon from "@redotech/redo-icons/search-sm.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo } from "react";

import { SegmentedToggle } from "../../onboardings/components/segmented-toggle";
// Reuse the merchants listing page's toolbar styling so the partners
// list reads as the same surface as `/onboardings/all/merchants`.
import * as styles from "../../onboardings/returns/returns-page.module.css";

export type StatusFilter = PartnerStatus | "all";

interface PartnersListingToolbarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  statusFilter: StatusFilter;
  onStatusFilterChange: (status: StatusFilter) => void;
  onCreateClick: () => void;
}

const STATUS_FILTER_OPTIONS: { value: StatusFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: "active", label: "Active" },
  { value: "paused", label: "Paused" },
  { value: "terminated", label: "Terminated" },
];

export const PartnersListingToolbar = memo(function PartnersListingToolbar({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  onCreateClick,
}: PartnersListingToolbarProps) {
  return (
    <div className={styles.filterButtons}>
      <SegmentedToggle
        ariaLabel="Status"
        onChange={onStatusFilterChange}
        options={STATUS_FILTER_OPTIONS}
        value={statusFilter}
      />
      <div className={styles.merchantSearchContainer}>
        <SearchIcon
          aria-hidden
          className={styles.merchantSearchIcon}
          height={16}
          width={16}
        />
        <input
          className={styles.merchantSearchInput}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by email, name, or referral code"
          type="text"
          value={searchQuery}
        />
      </div>
      <div className={styles.toolbarEndActions}>
        <RedoButton
          hierarchy="primary"
          IconLeading={PlusIcon}
          onClick={onCreateClick}
          size="sm"
          text="Create partner"
        />
      </div>
    </div>
  );
});
